var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagJp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "currentLayer"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h900v600H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 300,
    r: 180,
    fill: "#fe0000",
    className: "selected"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagJp);
export default __webpack_public_path__ + "static/media/flag_jp.378171c93c83305f0f59fda72cef598c.svg";
export { ForwardRef as ReactComponent };